import SSHeadline, {
  type ISSHeadlineProps,
} from "@core-components/title/SSHeadline";
import type { ReactNode } from "react";

interface IBgImageHeadlineProps {
  children: ReactNode;
}

const SSBgImageHeadline: React.FC<IBgImageHeadlineProps & ISSHeadlineProps> = ({
  children,
  props,
  ...rest
}) => {
  return (
    <SSHeadline
      props={{
        ...props,
        stack: {
          className: "py-14 xs:py-[150px]",
          ...props?.stack,
        },
        title: {
          ...props?.title,
          ta: "center",
          fz: "3.125rem",
        },
      }}
      {...rest}
    >
      {children}
    </SSHeadline>
  );
};

export default SSBgImageHeadline;
